import { BaseScript } from '../BaseScript';
import BaseViewModel from '../../../Models/BaseViewModel';
import { ScriptDescriptionType } from 'src/Modules/DynamicForm/Types';

export class HashtableScript extends BaseScript {
	varName: string | null = null;
	path: string | null = null;
	script: string | null = null;

	constructor(
		contextElement: BaseViewModel,
		script: ScriptDescriptionType,
		scriptPurpose: string,
	) {
		super(contextElement, script, scriptPurpose);
		const matches = this.Content?.match(/HashTable: ([^<>]*), ([^<>]*)/);
		if (matches && matches.length === 3) {
			this.varName = matches[1];
			this.path = matches[2].trim();
			this.script =
				this.script || this.path!.charAt(0) === '['
					? 'variable'
					: 'variable.' + this.path;
		}
	}

	/** Запустить скрипт в контексте hostObject */
	runScript = () => {
		// eslint-disable-next-line
		if (!this.Content) return null;
		try {
			// eslint-disable-next-line
			var variable = this.hostObject.GetContextVariable(this.varName!);
			// eslint-disable-next-line
			return eval(this.script!);
		} catch (e: any) {
			console.warn(e.message);
		}
		return null;
	};
}
